import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
const testimonials = [{
  initials: 'CR',
  name: 'Cecilia R.',
  location: 'Mendoza',
  pack: 'Megapack + Marca Gourmet',
  text: '"El sistema de stickers y el catálogo PDF cambiaron todo. Mis clientes me dicen que parece una marca de panadería gourmet. Subí los precios un 35% y no perdí ningún cliente."'
}, {
  initials: 'RM',
  name: 'Roberto M.',
  location: 'Buenos Aires',
  pack: 'Megapack Cocina',
  text: '"El Tomo 2 del chipá es una joya. Produje 60 bolitas crudas el sábado y las vendí durante 3 semanas desde el freezer. El negocio más inteligente que arranqué."'
}, {
  initials: 'SC',
  name: 'Sofía C.',
  location: 'La Plata',
  pack: 'Megapack Cocina',
  text: '"Los 120 textos del Bono 3 son oro puro. Copio, pego y me llegan pedidos. Antes me daba vergüenza vender. Ahora tengo lista de espera."'
}, {
  initials: 'PA',
  name: 'Pablo A.',
  location: 'Rosario',
  pack: 'Megapack + Marca Gourmet',
  text: '"La Calculadora de Precios del Bono 2 me mostró que estaba perdiendo $180 por alfajor. Ajusté los precios y tripliqué la ganancia sin vender más unidades."'
}];
export function TestimonialsBottom() {
  return <section className="py-12 px-4 bg-white" data-id="element-280">
      <div className="max-w-6xl mx-auto" data-id="element-281">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-12 font-serif" data-id="element-282">
          ❤️ MÁS FAMILIAS Y EMPRENDEDORES QUE YA LO TIENEN
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-283">
          {testimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-cream-light p-8 rounded-3xl shadow-sm border border-cream-dark" data-id="element-284">
              <div className="flex items-center gap-4 mb-4" data-id="element-285">
                <div className="w-14 h-14 bg-carbon text-white rounded-full flex items-center justify-center font-serif font-bold text-xl" data-id="element-286">
                  {t.initials}
                </div>
                <div data-id="element-287">
                  <div className="flex text-yellow-400 mb-1" data-id="element-288">
                    {[...Array(5)].map((_, j) => <Star key={j} className="w-4 h-4 fill-current" data-id="element-289" />)}
                  </div>
                  <p className="font-bold text-carbon" data-id="element-290">
                    {t.name}{' '}
                    <span className="text-carbon-lighter font-normal text-sm" data-id="element-291">
                      📍 {t.location}
                    </span>
                  </p>
                  <p className="text-xs font-medium text-brand-green bg-brand-green/10 inline-block px-2 py-0.5 rounded mt-1" data-id="element-292">
                    {t.pack}
                  </p>
                </div>
              </div>
              <p className="text-carbon-lighter italic leading-relaxed" data-id="element-293">
                {t.text}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}